export default {
    'zh_CN': {
        'property.office-equipment.id.label': '主键',
        'property.office-equipment.id.holder': '请输入主键',


        'property.office-equipment.id.required': '主键必填',
        'property.office-equipment.equipmentNo.label': '设备编号',
        'property.office-equipment.equipmentNo.holder': '请输入设备编号',
        'property.office-equipment.equipmentNo.max': '设备编号最多80个字符',

        'property.office-equipment.equipmentNo.required': '设备编号必填',
        'property.office-equipment.type.label': '设备类型',
        'property.office-equipment.type.holder': '请选择设备类型',
        'property.office-equipment.type.dictionary': ()=>[{value:1,label:'电脑'},{value:2,label:'打印机'},{value:3,label:'办公桌'}],
        'property.office-equipment.type.required': '设备类型必填',
        'property.office-equipment.remark.label': '备注',
        'property.office-equipment.remark.holder': '请输入备注',
        'property.office-equipment.remark.max': '备注最多255个字符',

        'property.office-equipment.remark.required': '备注必填',
        'property.office-equipment.createTime.label': '创建日期',
        'property.office-equipment.createTime.holder': '请输入创建日期',
        'property.office-equipment.createTime.required': '创建日期必填',
        'property.office-equipment.updateTime.label': '修改日期',
        'property.office-equipment.updateTime.holder': '请输入修改日期',
        'property.office-equipment.updateTime.required': '修改日期必填',
        'property.office-equipment.isDelete.label': '是否删除',
        'property.office-equipment.isDelete.holder': '请输入是否删除',


        'property.office-equipment.isDelete.dictionary': ()=>[{value:0,label:'删除'}],
        'property.office-equipment.isDelete.required': '是否删除必填'
    },
    'zh_TW': {
        'property.office-equipment.id.label': '主键',
        'property.office-equipment.id.holder': '請輸入主键',


        'property.office-equipment.id.required': '主键必填',
        'property.office-equipment.equipmentNo.label': '设备编号',
        'property.office-equipment.equipmentNo.holder': '請輸入设备编号',


        'property.office-equipment.equipmentNo.required': '设备编号必填',
        'property.office-equipment.type.label': '设备类型',
        'property.office-equipment.type.holder': '請輸入设备类型',


        'property.office-equipment.type.required': '设备类型必填',
        'property.office-equipment.remark.label': '备注',
        'property.office-equipment.remark.holder': '請輸入备注',


        'property.office-equipment.remark.required': '备注必填',
        'property.office-equipment.createTime.label': '创建日期',
        'property.office-equipment.createTime.holder': '請輸入创建日期',


        'property.office-equipment.createTime.required': '创建日期必填',
        'property.office-equipment.updateTime.label': '修改日期',
        'property.office-equipment.updateTime.holder': '請輸入修改日期',


        'property.office-equipment.updateTime.required': '修改日期必填',
        'property.office-equipment.isDelete.label': '是否删除',
        'property.office-equipment.isDelete.holder': '請輸入是否删除',


        'property.office-equipment.isDelete.required': '是否删除必填'
    },
    'en_US': {
        'property.office-equipment.id.label': 'id',
        'property.office-equipment.id.holder': 'Enter id',
        'property.office-equipment.id.max': 'id max length: 主键',


        'property.office-equipment.id.required': 'id required',
        'property.office-equipment.equipmentNo.label': 'equipmentNo',
        'property.office-equipment.equipmentNo.holder': 'Enter equipmentNo',
        'property.office-equipment.equipmentNo.max': 'equipmentNo max length: 设备编号',


        'property.office-equipment.equipmentNo.required': 'equipmentNo required',
        'property.office-equipment.type.label': 'type',
        'property.office-equipment.type.holder': 'Enter type',
        'property.office-equipment.type.max': 'type max length: 设备类型',


        'property.office-equipment.type.required': 'type required',
        'property.office-equipment.remark.label': 'remark',
        'property.office-equipment.remark.holder': 'Enter remark',
        'property.office-equipment.remark.max': 'remark max length: 备注',


        'property.office-equipment.remark.required': 'remark required',
        'property.office-equipment.createTime.label': 'createTime',
        'property.office-equipment.createTime.holder': 'Enter createTime',
        'property.office-equipment.createTime.max': 'createTime max length: 创建日期',


        'property.office-equipment.createTime.required': 'createTime required',
        'property.office-equipment.updateTime.label': 'updateTime',
        'property.office-equipment.updateTime.holder': 'Enter updateTime',
        'property.office-equipment.updateTime.max': 'updateTime max length: 修改日期',


        'property.office-equipment.updateTime.required': 'updateTime required',
        'property.office-equipment.isDelete.label': 'isDelete',
        'property.office-equipment.isDelete.holder': 'Enter isDelete',
        'property.office-equipment.isDelete.max': 'isDelete max length: 是否删除',


        'property.office-equipment.isDelete.required': 'isDelete required'
    }
}
